import { render, staticRenderFns } from "./sendToReward.vue?vue&type=template&id=d0349438&scoped=true&"
import script from "./sendToReward.vue?vue&type=script&lang=js&"
export * from "./sendToReward.vue?vue&type=script&lang=js&"
import style0 from "./sendToReward.vue?vue&type=style&index=0&id=d0349438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0349438",
  null
  
)

export default component.exports